<template>
    <div id="competences" @touch="swipeHandler"
    :style="{
        background: colors.theme == 'dark' ? '#000' : '#ffffff',
        color: colors.theme == 'dark' ? '#fff' : '#000'
    }">
        <div class="container-competences">
            <div class="accordion" 
                :class="[accordion.open == 'open-body' ? 'open' : 'closed', colors.theme == 'dark' ? 'dark' : 'light']"
                 v-for="(accordion, index) in accordionData" 
                 :key="index" 
                 @click="toogleAccordion(accordion)"
                 :style="{ 'height' : calcHeight(accordion), 'transition-duration' : '500ms', 'border-top': colors.theme == 'dark' ? '1px solid #364149' : '1px solid #ccc'}"
                 >
                <accordion-content 
                    :title="accordion.title"
                    :text="defineText(accordion.title, index)"
                    :open="accordion.open"
                    :index="index"
                    :group="accordion.group"
                    ></accordion-content>
            </div>
        </div>
    </div>
</template>

<script>
import AccordionContent from './AccordionContent'
import Bus from '../../main.js'
export default {
    name: 'Competences',
    // props: {
    //     reportData : {
            
    //     }
    // },
    components:{
        AccordionContent
    },
    data (){
        return{
                    componentsData: {
            headerTitle: 'perfil',
            backOption: true,
            backTo: 'Gráfico',
            buttonNextTitle: 'Finalizar',
        },
        pagination:{
            activeBefore: true,
            activeNext: true,
            beforeRoutePagination: 'graphic',
            nextRoutePagination: '/game-over'
        },
        pageNumberIndicator: 3,
        reportData: JSON.parse(localStorage.getItem('report')),
        colors: JSON.parse(localStorage.getItem("colors")),
        background: '',
        accordionData : [
            {
                group: this.$t("components.Report.Competences.accordionDataGroup[0]"),
                title : [
                    {
                        title : this.$t("components.Report.Competences.accordionDataTitle[0]"),
                        competence : true
                    },
                    {
                        title : this.$t("components.Report.Competences.accordionDataTitle[1]"),
                        competence : false
                    }
                ],
                text : '',
                open : 'open-body'
            },
            {
                group: this.$t("components.Report.Competences.accordionDataGroup[1]"),
                title : [
                    {
                        title : this.$t("components.Report.Competences.accordionDataTitle[2]"),
                        competence : true
                    },
                    {
                        title : this.$t("components.Report.Competences.accordionDataTitle[3]"),
                        competence : false
                    },
                ],
                text : '',
                open : 'closed-body'
            },
            {
                group: this.$t("components.Report.Competences.accordionDataGroup[2]"),
                title : [
                    {
                        title : this.$t("components.Report.Competences.accordionDataTitle[4]"),
                        competence : true
                    },
                    {
                        title : this.$t("components.Report.Competences.accordionDataTitle[5]"),
                        competence : false
                    },
                ],
                text : '',
                open : 'closed-body'
            },
            {   
                group: this.$t("components.Report.Competences.accordionDataGroup[3]"),            
                title : [
                    {
                        title : this.$t("components.Report.Competences.accordionDataTitle[6]"),
                        competence : true
                    },
                    {
                        title : this.$t("components.Report.Competences.accordionDataTitle[7]"),
                        competence : false
                    },
                ],
                text : '',
                open : 'closed-body'
            },
            {
                group: this.$t("components.Report.Competences.accordionDataGroup[4]"), 
                title : [
                    {
                        title : this.$t("components.Report.Competences.accordionDataTitle[8]"),
                        competence : true
                    },
                    {
                        title : this.$t("components.Report.Competences.accordionDataTitle[9]"),
                        competence : false
                    },
                ],
                text : '',
                open : 'closed-body'
            },


        ],
        accordionText:[
            [
                this.$t("components.Report.Competences.accordionText[0]"),
                this.$t("components.Report.Competences.accordionText[1]")
            ],
            [
                this.$t("components.Report.Competences.accordionText[2]"),
                this.$t("components.Report.Competences.accordionText[3]")
            ],
            [
                this.$t("components.Report.Competences.accordionText[4]"),
                this.$t("components.Report.Competences.accordionText[5]") 
            ],            
            [
                this.$t("components.Report.Competences.accordionText[6]") ,
                this.$t("components.Report.Competences.accordionText[7]") 
            ],
            [
                this.$t("components.Report.Competences.accordionText[8]") ,
                this.$t("components.Report.Competences.accordionText[9]") 
            ],
        ]
        }
    },

    async created(){
        const { antagonisticReport } = await this.$store.getters.getSimple(['antagonisticReport'])
        this.applyTextCompetence(antagonisticReport)
        if(this.open == 'open-body') this.background = 'transparent'
        if(this.colors.theme == 'dark' && !this.open == 'open-body') this.background =  '#0a1721'
        if(this.colors.theme == 'light' && !this.open == 'open-body') this.background =  '#f0f0f0'         
    },
    methods : {
        toogleAccordion(accordion){
           this.closedAllAccordion()
           if(accordion.open == 'open-body'){
                accordion.open = 'closed-body'
            }else{
                accordion.open = 'open-body'
            }
       },
       closedAllAccordion(){
            let accordions = this.accordionData
            accordions.forEach((accordion) => {
                accordion.open = 'closed-body'
            })
        },
        calcHeight(accordion){
            return accordion.open == 'closed-body' ? '10%' : '60%' 
        },
        defineText(titles, indexView){
            let indexTitle = 0
            titles.forEach((title, index) => {
                if(title.competence == true) indexTitle = index;
            })
            return this.accordionText[indexView][indexTitle];
        },
        applyTextCompetence(reports){
            for(let i = 0; i < 5; i++){
                let text = this.accordionText[i][0]
                if(reports[i] < reports[i + 5]){
                    text = this.accordionText[i][1]
                    this.accordionData[i].title[1].competence = true
                    this.accordionData[i].title[0].competence = false
                }
                this.accordionData[i].text = text
            }
        },
        swipeHandler (direction) {
            if(direction == 'right') this.$router.push(this.pagination.beforeRoutePagination) 
            if(direction == 'left') this.$router.push(this.pagination.nextRoutePagination)
            // console.log(direction)
        }        
    }
}
</script>

<style lang="scss">
#competences{
    position: relative;
}
    .container-competences{
        height: 100%;
        width: 100%;

        .accordion{
            height: 10%;

        .closed-body{
            z-index: 1;
            overflow: hidden;
            // height: 0px;
            transition-duration: 500ms;

            .accordion-header{
                height: 100%;
                padding: 0 5px;
                .header-title{
                    font-size: 10px;
                    
                    .title-text{
                        font-weight: 500;
                        font-size: 15px;
                    }

                    .title-text.title-bold{
                        font-size: 15px;
                        color: #000;
                        font-weight: 700;
                    }
                }
            }
            
        }
        }
        .accordion.light{
            .accordion-header{
                background-color: #f0f0f0 ;
            }
        }
        .accordion.dark{
            .accordion-header{
                background-color: #071620 ;
            }
        }
        .accordion.open.dark, .accordion.open.light{
            .accordion-header{
                background-color: transparent;
            }
        }        
    }

</style>